import {Component, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {BaseView} from "../../../../core/view/base.view";
import {IDialogComponent} from "../../../../common/dialog/iDialog.component";
import {DialogWithInput} from "../../../../common/dialog/dialogWithInput";
import {DialogModule} from "../../../../common/dialog/dialog.module";
import {FileLikeObject, FileUploader, FileUploadModule} from "ng2-file-upload";
import {IonicModule} from "@ionic/angular";
import {ActionButtonModule} from "../../../../core/component/action-button/action-button.module";
import {ButtonModule} from "../../../../core/component/button/button.module";

export interface CreateMessageAddAttachmentDialogInput {
  maxFileCount: number,
}
export interface CreateMessageAddAttachmentDialogOutput {
  uploadedFiles: FileLikeObject[];
}

@Component({
  templateUrl: './create-message-add-attachment-dialog.component.html',
  styleUrls: ['./create-message-add-attachment-dialog.component.scss'],

  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    FileUploadModule,
    IonicModule,
    ActionButtonModule,
    ButtonModule,
  ]
})
export class CreateMessageAddAttachmentDialogComponent extends BaseView implements IDialogComponent<CreateMessageAddAttachmentDialogInput, CreateMessageAddAttachmentDialogOutput>,
OnInit {
  dialog: DialogWithInput<CreateMessageAddAttachmentDialogInput, CreateMessageAddAttachmentDialogOutput>;
  hasBaseDropZoneOver = false;
  fileUploader: FileUploader = new FileUploader({});

  constructor() {
    super();
  }

  ngOnInit() {
    this.fileUploader.options.queueLimit = this.dialog.input.maxFileCount;
  }

  fileOverDropZone(ev): void {
    this.hasBaseDropZoneOver = ev;
  }

  validate() {
    this.dialog.close({
      uploadedFiles: this.fileUploader.queue.map((fileItem) => {
        return fileItem.file;
      })
    })
  }
}
